import styles from './index.module.scss'
import GenerateResults from './GenerateResultsPage'
import { GenerateContext } from '../hooks/GenerateContext'
import { useContext, forwardRef, useMemo, useRef, useState } from 'react'
import PlaceholderPage from './PlaceholderPage'
import { IMAGE_TYPE } from "@utils/CONST"
import SmartDetailPagePreview from './SmartDetailPagePreview'
import PreviewBottomActions from './SmartDetailPagePreview/components/PreviewBottomActions'

const MiddleComp = forwardRef((props, ref) => {

    const {
        projectId,
        imageType,
        currentInputType,
    } = useContext(GenerateContext)
    const previewBottomActionsRef = useRef(null)
    const [previewTasks, setPreviewTasks] = useState([])
    const pickedSortedItems = useMemo(() => {
        return previewTasks
            .flatMap(group => group || [])
            .filter(item => item?.picked)
            .map((item, index) => ({ item, index }))
            .sort((a, b) => {
                const aSortIdx = Number(a?.item?.sortIdx)
                const bSortIdx = Number(b?.item?.sortIdx)
                const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
                const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
                if (aValue !== bValue) return aValue - bValue
                return a.index - b.index
            })
            .map(({ item }) => item)
    }, [previewTasks])
    const previewImageUrls = useMemo(() => {
        return pickedSortedItems
            .map(item => item?.results?.[0]?.hdImage || item?.results?.[0]?.image)
            .filter(Boolean)
    }, [pickedSortedItems])
    const isSmartDetailGenerating = useMemo(() => {
        return previewTasks
            .flatMap(group => group || [])
            .some(item => ['started', 'pending', 'processing'].includes(item?.status))
    }, [previewTasks])
    const selectedTaskIds = useMemo(() => {
        return [...new Set(
            pickedSortedItems
                .map(item => item?.taskId)
                .filter(Boolean)
        )]
    }, [pickedSortedItems])
    const isSmartDetailPageResult = projectId && imageType == IMAGE_TYPE.SMART_DETAILA_PAGE

    return (
        <div className={styles.MiddleComp}>
            {
                projectId ? (
                    isSmartDetailPageResult ? (
                        <div className={styles.SmartDetailPageWrapper}>
                            <div className={styles.GenerateResultsLayout}>
                                <GenerateResults
                                    projectId={projectId}
                                    ref={ref}
                                    className={styles.GenerateResultsMain}
                                    onTasksChange={setPreviewTasks}
                                    hideFooter
                                />
                                <SmartDetailPagePreview
                                    tasks={pickedSortedItems}
                                    isGenerating={isSmartDetailGenerating}
                                    onPreviewLongImage={() => previewBottomActionsRef?.current?.previewLongImage?.()}
                                />
                            </div>
                            <PreviewBottomActions
                                ref={previewBottomActionsRef}
                                imageUrls={previewImageUrls}
                                selectedTaskIds={selectedTaskIds}
                                isGenerating={isSmartDetailGenerating}
                            />
                        </div>
                    ) : (
                        <GenerateResults projectId={projectId} ref={ref} />
                    )
                ) : (
                    imageType != IMAGE_TYPE.FUSION_WEAR && <PlaceholderPage imageType={imageType} inputType={currentInputType} />
                )
            }
        </div>
    )
})

export default MiddleComp
